import { Box, Stack } from '@mui/system';
import {
  GlobalSearchResult,
  GlobalSearchResultType,
  getGlobalSearchModelIcon,
} from 'GlobalSearchResult';
import React from 'react';
import { StyledHeading, StyledPaper } from '../styles/styles';

interface HeaderGlobalSearchResultsProps {
  results: GlobalSearchResult[];
  selectedIndex: number;
  onResultClick: (result: GlobalSearchResult) => void;
}

function getResultIcon(type: GlobalSearchResultType) {
  const cfg = getGlobalSearchModelIcon(type);
  const IconComponent = cfg?.icon;
  return IconComponent ? <IconComponent /> : null;
}

const HeaderGlobalSearchResults: React.FC<HeaderGlobalSearchResultsProps> = ({
  results,
  selectedIndex,
  onResultClick,
}) => (
  <StyledPaper
    elevation={3}
    sx={{
      position: 'absolute',
      top: '100%',
      left: 0,
      width: '100%',
      mt: 1,
      p: 1,
      zIndex: 10,
    }}
  >
    <Stack spacing={1}>
      {results.map((result, idx) => (
        <Box
          onClick={() => onResultClick(result)}
          key={idx}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            fontSize: '10px',
            cursor: 'pointer',
            border:
              idx === selectedIndex ? '2px dotted rgba(0, 0, 0, 0.4)' : '2px solid transparent',
            borderRadius: 1,
            p: 1,
            transition: 'border-color 0.1s ease',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
              border: '2px dotted rgba(0, 0, 0, 0.2)',
            },
          }}
        >
          {getResultIcon(result.type)}
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <StyledHeading
              sx={{
                fontSize: 'inherit',
                p: 0,
                m: 0,
                textAlign: 'left',
              }}
            >
              {result.label}
            </StyledHeading>
            <StyledHeading
              sx={{
                fontSize: 'inherit',
                p: 0,
                m: 0,
                textAlign: 'left',
              }}
              headerVariant="subheading"
            >
              {result.subtitle}
            </StyledHeading>
          </Box>
        </Box>
      ))}
    </Stack>
  </StyledPaper>
);

export default HeaderGlobalSearchResults;
